import React from "react";
import { motion } from "framer-motion";
import "./hero.css";

const container = { hidden: {}, show: { transition: { staggerChildren: 0.2 } } };
const item      = { hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } };

export default function Hero() {
  return (
    <section id="home" className="hero">
      <motion.div className="hero-text" variants={container} initial="hidden" animate="show">
        <motion.h1 variants={item}>
          Hi, I&apos;m <span className="accent">Emil Risko</span>
        </motion.h1>

        <motion.h2 variants={item}>Frontend Developer</motion.h2>

        <motion.p variants={item}>
          I craft responsive, user-friendly web apps with React and CSS.
        </motion.p>

        {/* --- КНОПКИ + код --- */}
        <motion.div className="hero-btns" variants={item}>
          {/* обёртка нужна, чтобы overlay был соседним элементом */}
          <div className="talk-wrapper">
            <a href="#contact" id="talk-btn" className="btn outline">Let&apos;s Talk</a>
            <pre className="code-overlay">
              const&nbsp;greeting&nbsp;=&nbsp;"Hello,&nbsp;world!";
            </pre>
          </div>
        </motion.div>

        <motion.div className="socials" variants={item}>
          <a href="#"><i className="fa-brands fa-github" /></a>
          <a href="#"><i className="fa-brands fa-linkedin" /></a>
        </motion.div>
      </motion.div>
    </section>
  );
}
